// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.mobile-activity[data-v-06858bb0]{\r\n\tposition: fixed;\r\n\ttop:0;\r\n\tleft:0;\r\n\theight:100vh;\r\n\twidth:100vw;\r\n\tz-index: 1;\r\n\toverflow-x:hidden;\r\n\toverflow-y:hidden;\r\n\tbackground-color: white;\n}\r\n\r\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
